var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isSharing)?_c('Duel_Tutorial'):_vm._e(),_c('Duel_Feed',{ref:"feed",attrs:{"duel-collection":_vm.duelCollection}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }